export default __webpack_public_path__ + "static/media/DigitalBusinessPayments.9c519df8.pdf";